export enum FormatingTypes {
  Unknown = 0,
  Heading = 1,
  Paragraph = 2,
}
